/* Cart failures must remain readable and must never trigger a blind duplicate add. */
(() => {
  window.theme = window.theme || {};
  const state = () => window.Alpine?.store('cart');
  window.theme.cartFeedback = {
    clear() {
      const cart = state();
      if (cart) cart.errorMessage = '';
    },
    failure(error, operation) {
      const status = Number(error?.response?.status || 0);
      const description = error?.response?.data?.description;
      const uncertain = operation !== 'refresh' && (!status || status >= 500);
      let message;
      if (operation === 'refresh') {
        message = 'We could not refresh your bag. Please review your bag before making another change.';
      } else if (status === 422 && typeof description === 'string' && description.trim()) {
        message = description.trim();
      } else if (uncertain) {
        message = 'We could not confirm this change. Please review your bag before trying again, so you do not add an item twice.';
      } else {
        message = 'We could not update your bag. Please review your bag and try again.';
      }
      const cart = state();
      if (cart) cart.errorMessage = message;
      return { success: false, uncertain, error: message };
    }
  };
})();
